import { ref, computed } from "vue"
import { defineStore } from "pinia"
import { useRuntimeStore } from "@/store/runtime"
// import { v4 as uuidv4 } from 'uuid'


export const useHistoryStore = defineStore('historyStore', () => {
  const runtimeStore = useRuntimeStore();

  const history = ref({})


  const userPk = computed(()=>{
    return runtimeStore?.session?.user?.pk
  })

  // if (!userPk) {
  //   console.log("👤 userPk not found")
  //   return { history }
  // }

  const save = () => {
    localStorage.setItem("history", JSON.stringify(history.value))
    console.log("💾 history saved (to localStorage)")
  }

  const load = () => {
    console.log("📅 historyStore load called")


    // const userPk = runtimeStore?.session?.user?.pk

    if (!userPk.value) {
      console.log("👤 userPk not found")
      return
    }

    if (localStorage.getItem("history")) {
      history.value = JSON.parse(localStorage.getItem("history"))
    }

    
    if (!history.value?.[userPk.value]) {      // default per user
      console.log("📦 history empty")
      history.value[userPk.value] = []
      
      
      // fill if empty
      // for (let i = 0; i < 100; i++) {
      //   history.value[userPk.value].push({
      //     uuid: crypto.randomUUID(),
      //     timestamp: new Date() * Math.random(),
      //     coords: [7.1927529,45.5398782],
      //     label: "an entry",
      //     q250: 10103
      //   })
      // }

      save()
    }
  }


  const userHistory = computed(() => history.value[userPk.value]?.sort((a, b) => {
    return b.timestamp - a.timestamp
  }))


  const pushInUserHistory = (entry) => {
    console.log("➕ pushInUserHistory")

    // uuid: crypto.randomUUID(),
    //     timestamp: new Date() * Math.random(),
    //     coords: [7.1927529,45.5398782],
    //     label: "an entry",
    //     q250: 10103

    if (!entry.uuid) {
      // console.error("no uuid")
    }
    if (!entry.timestamp) {
      // console.error("no timestamp")
      entry.timestamp = 0
    }
    if (!entry.coords) {
      // console.error("no coords")
      entry.coords = undefined
    }
    if (!entry.label) {
      // console.error("no label")
      entry.label = "?"
    }
    if (!entry.type) {
      // console.error("no type")
      entry.type = "generic"
    }

    entry.created = Date.now()

    history.value[userPk.value].push(entry)
    save()
  }

  const deleteUserHistory = () => {
    console.log("🗑️ deleteUserHistory")
    history.value[userPk.value] = []
    save()
  }


  load()

  return {
    userHistory,
    deleteUserHistory,
    pushInUserHistory,
  }
})




